import { bootToolPage } from '../lib/boot-tool'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('gradient')
document.body.insertAdjacentHTML(
  'beforeend',
  stageMarkup({ controls: ['exit', 'prev', 'next', 'hide'] }),
)
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

const modes = ['gray-h', 'gray-v', 'red', 'green', 'blue', 'steps'] as const
let modeIndex = 0

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  const stage = document.querySelector<HTMLElement>('[data-stage-root]')
  const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')
  if (!stage || !canvas) return

  const paint = () => {
    const mode = modes[modeIndex]
    if (mode === 'gray-h') canvas.style.background = 'linear-gradient(90deg,#000,#fff)'
    else if (mode === 'gray-v') canvas.style.background = 'linear-gradient(180deg,#000,#fff)'
    else if (mode === 'red') canvas.style.background = 'linear-gradient(90deg,#000,#f00)'
    else if (mode === 'green') canvas.style.background = 'linear-gradient(90deg,#000,#0f0)'
    else if (mode === 'blue') canvas.style.background = 'linear-gradient(90deg,#000,#00f)'
    else {
      const stops = Array.from({ length: 17 }, (_, i) => {
        const v = Math.round((i / 16) * 255)
        return `rgb(${v} ${v} ${v}) ${(i / 16) * 100}%`
      }).join(',')
      canvas.style.background = `linear-gradient(90deg,${stops})`
    }
    const label = stage.querySelector('[data-stage-label]')
    if (label) label.textContent = mode
  }

  const close = openStage(stage, {
    onExit: () => {
      close()
    },
    onPrev: () => {
      modeIndex = (modeIndex - 1 + modes.length) % modes.length
      paint()
    },
    onNext: () => {
      modeIndex = (modeIndex + 1) % modes.length
      paint()
    },
  })
  paint()
})

void locale
